import app from '../services/app'

export default {
  async connectProperty(data) {
    let property

    try {
      property = await app.connectProperty(data)
    } catch (error) {
      property = false
    }

    return property ? property.data : false
  },

  async getCountries(language) {
    let countries

    try {
      countries = await app.getCountryList(language)
    } catch (error) {
      countries = false
    }

    return countries ? countries.data : false
  }
}
